import styled from 'styled-components';

const styledRefundPolicy = styled.div`

h1{
	font-size: 24px;
	font-weight: bold
}
li{
	font-size: 13px;
	font-weight: normal;
	line-height: 1.6
}
`;

export default styledRefundPolicy;


// WEBPACK FOOTER //
// client/containers/RefundPolicy/StyledRefundPolicy.js